// src/pages/BEdPage.js
import React from 'react';
import Layout from '../components/Layout/Layout';
import bedPdfFile from '../images/BEDSECTION.pdf';

const BEdPage = () => {
  return (
    <Layout>
      <div id="bed" className="page-container" style={{ maxWidth: '1000px', fontSize: '0.90rem', margin: '40px auto', padding: '0 20px', minHeight: '300px' }}>
        
        <h2 style={{ color: '#990000', borderBottom: '3px solid #990000', paddingBottom: '15px', marginBottom: '40px', textAlign: 'center', fontSize: '2.2rem', fontWeight: 'bold' }}>
          Arts Department - B.Ed Syllabus
        </h2>
        
        <div style={{ backgroundColor: '#fff5f5', border: '1px solid #ffecec', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 15px rgba(153, 0, 0, 0.05)' }}>
          <h3 style={{ color: '#990000', textAlign: 'center', marginBottom: '30px', fontSize: '1.8rem', fontWeight: 'bold' }}>
            Embedded B.Ed Syllabus Document
          </h3>
          
          <iframe 
            src={bedPdfFile} 
            width="100%" 
            height="800px" 
            title="B.Ed Syllabus Document" 
            style={{ border: 'none', backgroundColor: '#333', borderRadius: '4px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }} 
          />
        </div>

      </div>
    </Layout>
  );
};

export default BEdPage;
